import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../records/grids/columns/columnDefinitionService";
import {
  ColumnDefinitionSetService,
  ColumnDefinitionSetServiceProvider,
  vsProviderName as ColumnDefinitionSetServiceProviderName,
  vsServiceName as ColumnDefinitionSetServiceName,
} from "../../../records/grids/columns/columnDefinitionSetService";
import {
  GridConfiguration,
  RecordGridViewService,
  RecordGridViewServiceProvider,
  vsProviderName as RecordGridViewServiceProviderName,
  vsServiceName as RecordGridViewServiceName,
} from "../../../records/views/recordGridView";
import {
  GridSettingsService,
  vsName as GridSettingsServiceName,
} from "../../../records/grids/settings/gridSettingsService";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../records/server/serverUtility";

import {
  moneyValueGetterFactory,
  percentageValueGetterFactory,
} from "../../../records/grids/cells/valueGetters";
import { RecordDataSource } from "../../../records/grids";

export { machineGameConfigurationObjectName as vsObjectName } from "../../shared/names";
import { machineGameConfigurationObjectName } from "../../shared/names";
import { vsObjectName as machineTypeIdObjectName } from "./machineTypeId";

machineGameConfig.$inject = [
  RecordGridViewServiceProviderName,
  ColumnDefinitionSetServiceProviderName,
];
export function machineGameConfig(
  recordGridViewServiceProvider: RecordGridViewServiceProvider,
  columnDefinitionSetServiceProvider: ColumnDefinitionSetServiceProvider
) {
  recordGridViewServiceProvider.addGridConfiguration(
    machineGameConfigurationObjectName,
    [
      ServerUtilityName,
      GridSettingsServiceName,
      RecordGridViewServiceName,
      (
        serverUtility: ServerUtility,
        gridSettingsService: GridSettingsService,
        recordGridViewService: RecordGridViewService
      ): GridConfiguration => {
        const machineTypeIdGridConfig =
          recordGridViewService.getGridConfiguration(machineTypeIdObjectName);
        return {
          columnDefinitionSet: machineGameConfigurationObjectName,
          defaultSort: RecordGridViewService.combineSort(
            machineTypeIdGridConfig?.defaultSort,
            "Order"
          ),
          gridDataSource: new RecordDataSource(
            serverUtility,
            "/api/machines/MachineGameConfiguration"
          ),
          gridSettings: gridSettingsService.getGridSettings(
            Symbol(machineGameConfigurationObjectName)
          ),
          namePlural: "Machine Game Configurations",
          nameSingular: "Machine Game Configuration",
          showAddButton: false,
        };
      },
    ]
  );

  columnDefinitionSetServiceProvider.addColumnDefinitionSet(
    machineGameConfigurationObjectName,
    [
      ColumnDefinitionServiceName,
      ColumnDefinitionSetServiceName,
      (
        columnDefinitionService: ColumnDefinitionService,
        columnDefinitionSetService: ColumnDefinitionSetService
      ) => {
        const moneyValueGetter = moneyValueGetterFactory();
        const percentageValueGetter = percentageValueGetterFactory();
        const cols = [
          columnDefinitionService.getNumberColDef({
            field: "Id",
            hide: true,
          }),
          columnDefinitionService.getStringColDef({
            field: "MachineThemeName",
            header: "Theme",
          }),
          columnDefinitionService.getStringColDef({
            field: "MachineDenominationName",
            header: "Denomination",
          }),
          columnDefinitionService.getNumberColDef({
            field: "PL",
            header: "P/L",
          }),
          columnDefinitionService.getNumberColDef({
            field: "MinCredit",
            header: "Min Credit",
          }),
          columnDefinitionService.getNumberColDef({
            field: "MinBet",
            header: "Min Bet",
            valueGetter: moneyValueGetter,
          }),
          columnDefinitionService.getNumberColDef({
            field: "MC",
            header: "M/C - Credits",
          }),
          columnDefinitionService.getNumberColDef({
            field: "MaxBet",
            header: "Max Bet",
            valueGetter: moneyValueGetter,
          }),
          columnDefinitionService.getNumberColDef({
            field: "C2CCredit",
            header: "C2C",
            hide: true,
          }),
          columnDefinitionService.getNumberColDef({
            field: "C2C - Credits",
            header: "C2C $",
            hide: true,
            valueGetter: moneyValueGetter,
          }),
          columnDefinitionService.getNumberColDef({
            field: "GamePar",
            header: "PAR",
            valueGetter: percentageValueGetter,
          }),
          columnDefinitionService.getNumberColDef({
            field: "ParSheetPar",
            header: "Par Sheet Par",
            valueGetter: percentageValueGetter,
          }),
          columnDefinitionService.getStringColDef({
            field: "ProgressiveDefinitionGameName",
            header: "Progressive Game",
          }),
          columnDefinitionService.getStringColDef({
            field: "Variation",
          }),
          columnDefinitionService.getStringColDef({
            field: "Paytable ID",
          }),
          columnDefinitionService.getNumberColDef({
            field: "RtpPercentage",
            header: "RTP%",
            valueGetter: percentageValueGetter,
          }),
          ...columnDefinitionSetService.getColumnDefinitionSet(
            machineTypeIdObjectName
          ),
        ];

        return cols;
      },
    ]
  );
}
